import React, {Component, forwardRef} from 'react'
import FJUtil from "../../../util/FJUtil";
import classNames from 'classnames';
import $ from 'jquery';
import FJFontFamilyPanel from './FJFontFamilyPanel';
import FJDropDown from "fj-components/FJDropDown"
import FJCustomScroll from "../../../common/component/FJCustomScroll";
import FJArrowUpDownIcon from '../../../icon/FJArrowUpDownIcon.svg';
import styles from './FJFontFamilyContainer.module.less';
import InlineSVG from "react-inlinesvg"
import FJLocalStore from "../../../store/FJLocalStore";
import FJCoreUtil from "../../../core/util/FJCoreUtil";

const ForwardTrigger = forwardRef(((props, ref) => {
  let {btnClass, fontFamily, active, previewClass} = props;
  return (
    <div ref={ref} className={classNames(btnClass, {active}, 'u-tooltip-bottom')} tooltip={FJLocalStore._('font')}>
      <div className={classNames(styles['c-font-preview-container'], previewClass)} onDragStart={e => {
        e.stopPropagation();
        e.preventDefault()
      }}>
        <InlineSVG src={FJUtil.getFontPreview(fontFamily)}/>
      </div>
      <InlineSVG className={styles['c-icon-font-up-down']} src={FJArrowUpDownIcon} element='div'/>
    </div>
  );
}));

class FJFontFamilyContainer extends Component {

  constructor(props) {
    super(props);
    this.fontFamilyContent = React.createRef();
    this.dropDown = React.createRef();
  }

  _dataChange = (data) => {
    if (this.props.fontFamilyChange)
      this.props.fontFamilyChange(data.fontName);
  };
  fitOverlayPosition = () => {
    this.dropDown.current.resizeSensor();
  };
  fitPositionCallback = () => {
    if (this.fitPositionCallbackTimeer) {
      clearTimeout(this.fitPositionCallbackTimeer);
    }
    this.fitPositionCallbackTimeer = setTimeout(() => {
      $(this.fontFamilyContent.current).css({height: 418});
      let {bottom, top} = this.fontFamilyContent.current.getBoundingClientRect();
      let bodyHeight = document.body.offsetHeight;
      if (bottom > bodyHeight) {
        let curHeight = bodyHeight - top - 20;
        if (curHeight > 0) {
          $(this.fontFamilyContent.current).css({height: curHeight});
        }
      }
    }, 100)
  };

  _toggleTooltip = (ele, bool) => {
    FJUtil.toggleTooltip(ele, bool);
  };

  render() {
    let {fontFamily, disabled, loadingFonts, className, dropDownClassName, contentClassName, previewClassName} = this.props;
    let btnClass = classNames('u-tooltip-bottom u-button-cursor', styles['c-font-btn'], {disabled: disabled}, className);

    return (
      <FJDropDown overlay={
        <div className={classNames(styles['c-font-family-popup-panel'], dropDownClassName)}>
          <div ref={this.fontFamilyContent} className={classNames(styles['c-font-family-content'], contentClassName)}>
            <FJCustomScroll thumbHorizontalClassName={styles['c-font-family-content-horizontal']}>
              <FJFontFamilyPanel
                activeFontName={fontFamily}
                loadingFonts={loadingFonts}
                fontFamilyList={this.props.fontFamilyList}
                dataChange={this._dataChange}
              />
            </FJCustomScroll>
          </div>
        </div>
      }
                  arrowClass='c-arrow-bg'
                  overlayClassName='c-overlay-bg'
                  placement='bottomLeft'
                  zIndex={100}
                  hasArrow={false}
                  triggerClick={() => {FJCoreUtil.triggerBodyMousedown()}}
                  canTriggerActive
                  fitPositionCallback={this.fitPositionCallback}
                  ref={this.dropDown}
                  isTopLayer
                  toggleTooltip={this._toggleTooltip}
                  disabled={this.props.disabled}>
        <ForwardTrigger btnClass={btnClass} fontFamily={fontFamily} previewClass={previewClassName} />
      </FJDropDown>
    );
  }
}

export default FJFontFamilyContainer;
